class BBHRelatedCarousel extends HTMLElement {
  connectedCallback() {
    if (this.dataset.bbhCarouselReady === 'true') return;

    this.track = this.querySelector('.bbh-related-products__track');
    this.previousButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.track || !this.previousButton || !this.nextButton) return;

    this.dataset.bbhCarouselReady = 'true';
    this.previousButton.addEventListener('click', (event) => this.move(event, -1));
    this.nextButton.addEventListener('click', (event) => this.move(event, 1));
    this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });

    this.resizeObserver = new ResizeObserver(() => this.updateButtons());
    this.resizeObserver.observe(this.track);
    this.updateButtons();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  getStep() {
    const items = this.track.querySelectorAll('.slider__slide');
    if (items.length > 1) return items[1].offsetLeft - items[0].offsetLeft;
    return items[0]?.offsetWidth || this.track.clientWidth;
  }

  move(event, direction) {
    event.preventDefault();

    const step = this.getStep();
    const visibleItems = Math.max(1, Math.floor((this.track.clientWidth + 1) / step));
    const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    const target = Math.min(maxScroll, Math.max(0, this.track.scrollLeft + direction * step * visibleItems));

    this.track.scrollTo({ left: target, behavior: 'smooth' });
  }

  updateButtons() {
    const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    this.previousButton.disabled = this.track.scrollLeft <= 2;
    this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;
  }
}

if (!customElements.get('bbh-related-carousel')) {
  customElements.define('bbh-related-carousel', BBHRelatedCarousel);
}
